import React, { useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getBrowserLanguage, getTranslations } from "./translations";
import { CURRENT_TERMS_VERSION } from "../config/termsConfig";
import "./TermsUpdateModal.css";

const TermsUpdateModal = ({ authProps }) => {
  const { user, isUserDataLoading, acceptUserTerms, acceptedTermsVersion } = authProps;
  const [texts, setTexts] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const lang = getBrowserLanguage();
    setTexts(getTranslations(lang)?.termsUpdate || {});
  }, []);

  if (!user || isUserDataLoading) return null;

  // Se o usuário ainda não passou do cadastro inicial, não mostramos o modal
  if (!acceptUserTerms) return null;

  // Se já está na versão mais atual dos termos, não mostra nada
  if (acceptedTermsVersion === CURRENT_TERMS_VERSION) return null;

  // Não exibe nas telas de login/boas-vindas ou cadastro para evitar loop de fluxo
  const path = window.location.pathname;
  if (path === "/welcome" || path === "/addUser" || path.startsWith("/privacy-policy")) return null;

  const handleAcceptTerms = async () => {
    try {
      setIsUpdating(true);
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        acceptedTermsVersion: CURRENT_TERMS_VERSION,
      });
    } catch (error) {
      console.error("Erro ao aceitar termos atualizados:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="terms-update-backdrop">
      <div className="terms-update-modal-card">
        <div className="terms-update-header">
          <h2>{texts.title || "Termos de Uso Atualizados"}</h2>
        </div>

        <div className="terms-update-body">
          <p className="terms-update-description">
            {texts.description ||
              "Atualizamos nossos Termos de Serviço e Política de Privacidade para melhorar sua experiência. Para continuar navegando e participando da nossa comunidade, é necessário aceitar os novos termos."}
          </p>

          <div className="terms-update-links">
            <a href="/privacy-policy/?tab=terms" target="_blank" rel="noopener noreferrer" className="terms-link-item">
              📄 {texts.readTerms || "Ler Termos de Serviço"}
            </a>
            <a href="/privacy-policy/?tab=privacy" target="_blank" rel="noopener noreferrer" className="terms-link-item">
              🔒 {texts.readPrivacy || "Ler Política de Privacidade"}
            </a>
          </div>

          <div className="terms-update-notice">
            <p>
              ⚠️ {texts.agreementNote ||
                "Continuar a utilizar o site ou aplicativo implica no seu consentimento e aceitação das novas diretrizes."}
            </p>
          </div>
        </div>

        <div className="terms-update-footer">
          <button
            className="terms-update-btn"
            onClick={handleAcceptTerms}
            disabled={isUpdating}
          >
            {isUpdating ? "..." : (texts.understandButton || "Entendi e concordo")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsUpdateModal;
